import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-variant"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-slot": "item-media",
        "data-variant": $props.variant,
        class: _normalizeClass($setup.cn($setup.mediaVariants({ variant: $props.variant }), $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 10 /* CLASS, PROPS */, _hoisted_1));
}
